// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"184":"2448a7c0","289":"1729714b","454":"e6a8cc83","609":"6cb13eeb","948":"537cbd83"}[chunkId] + ".chunk.css";
};